export default __webpack_public_path__ + "static/mid-5f6bd2f5fed2d37d4d190286cc68bc7f.jpg";